import logger from 'redux-logger'

export default logger
